import f3 from "assets/images/posts/f3.jpg";

const PostLink = () => {
    return (
        // <a href="#">
        <div className="post-link w-full flex flex-col items-start justify-center gap-3">
            {/* <!-- Link image --> */}
            <div className="link-image relative w-full">
                <div className="link-media-overlay"></div>
                <img src={f3} alt="" />
            </div>
            {/* <!-- Link content --> */}
            <div className="link-content">
                <small>website.com</small>
                <h4>
                    <a href="#">Some heading here ?</a>
                </h4>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Officia temporibus, illum sequi neque tempore repudiandae?.
                </p>
            </div>
        </div>
        // </a>
    );
};

export default PostLink;
